// extracted by mini-css-extract-plugin
module.exports = {"section":"section__2DwGS","text":"text__2bhnH","button":"button__29fy8"};